<style lang="scss">
    :root{
        --top-bar: 50px;
        --left-menu: 221px;
    }
    .container{
        height: 100%;
        width: 100%;
        .topbar-wrap {
            height: var(--top-bar);
            line-height: var(--top-bar);
            background: #373d41;
            padding: 0px;
            color: #fff;
        }
        .topbar-title{
            float: left;
            text-align: left;
            padding-left: 10px;
            border-left: 1px solid #000;
            img{
                vertical-align: middle;
                margin-right: 10px;
            }
            .topbar-title h4{
                font-weight: normal;
            }
        }
        .topbar-btn {
            color: #fff;
        }
        .topbar-account {
            float: right;
            padding-right: 12px;
        }
        .topbar-wrap .userinfo-inner{
            cursor: pointer;
            color: #fff;
            padding-left: 10px;
        }
        .container-main{
            position: absolute;
            left: 0;
            top: var(--top-bar);
            bottom: 0;
            right: 0;
            overflow-y: auto;
        }
        aside.showSidebar{
            position: fixed;
            left: 0;
            top: var(--top-bar);
            bottom: 0;
            width: var(--left-menu);
            background: #f6f7f9;
            border-right: 1px solid #e2e3e5;
            overflow-y: auto;
        }
        .content-container{
            margin-left: calc(var(--left-menu) + 1px);
            background: #fff;
            overflow-y: auto;
            padding-bottom: 1px;
            background: #fafafa;
            position: absolute;
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
            /*padding: 10px;*/
        }
        aside .el-menu{
            border: none;
            /*border-right: 1px solid #e2e3e5;*/
        }
        .content-bread{
            padding: 12px 15px;
            background: #fff;
            height: 20px;
            line-height: 20px;
        }
        .content-page{
            height: calc(100% - 64px);
            padding: 10px;
            /*overflow-y: auto;*/
        }
        .warp-breadcrum {
            padding: 15px 15px;
            background: #F0F2F5;
            overflow: hidden;
        }
        .contentbox{
            background: #fff;
            padding: 20px;
            min-height: calc(100% - 40px);
        }
    }
    /* 修改垂直滚动条 ----------------  菜单*/
    .container aside.showSidebar::-webkit-scrollbar{
        display: none; /* 修改宽度 */
    }
    /*!* 修改滚动条轨道背景色  *!*/
    /*.container aside.showSidebar::-webkit-scrollbar-track{*/
        /*background-color: #f1f1f1;*/
    /*}*/
    
    /*!* 修改滚动条滑块颜色 *!*/
    /*.container aside.showSidebar::-webkit-scrollbar-thumb{*/
        /*background-color: #888;*/
    /*}*/
    /*!* 修改滚动条滑块悬停时的颜色 *!*/
    /*.container aside.showSidebar::-webkit-scrollbar-thumb:hover{*/
        /*background-color: #555;*/
    /*}*/
    .container .el-menu-item:hover, .container .el-submenu .el-menu-item:hover, .container .el-submenu .el-submenu__title:hover{
        background-color: #e3e5eb !important;
    }
    .topbar-account .el-input__inner{
        height: 32px;
        line-height: 32px;
    }
</style>
<template>
    <div class="container">
        <!--顶部-->
        <div class="topbar-wrap">
            <div class="topbar-title">
                <!--<span><img src="../../assets/images/logo_icon.png" height="40" style="vertical-align: middle;margin-right: 10px;"/>云书小说</span>-->
                <h4>
                    <a>
                        <img src="@/assets/images/logo01.png" height="40"/>
                        <span v-if="hostname == 't.zuok.cn'">作客小程序管理平台 - 测试站</span>
                        <span v-else-if="hostname == '192.168.110.113'">作客小程序管理平台 - 本地</span>
                        <span v-else>作客小程序管理平台</span>
                    </a>
                </h4>
            </div>
            <div class="fr">
                <!--<div style="display: inline-block; margin-right: 20px;" class="el-input&#45;&#45;small">-->
                   <!--<app-list @getAppId="getAppId" :appId="appId"></app-list>-->
                <!--</div>-->
                <div style="display: inline-block; margin-right: 15px;">
                     <app-list @getAppObj="getAppObj" :appObj="appObj" :clear="'noclear'"></app-list>
                    <!--<el-form :inline="true" size="small" class="demo-form-inline">-->
                        <!--<el-form-item style="margin-bottom: 0; position: relative; top: 8px;">-->
                            <!--<app-list @getAppId="getAppId" :appId="appId" :clear="'noclear'"></app-list>-->
                        <!--</el-form-item>-->
                    <!--</el-form>-->
                </div>
                <div class="topbar-account topbar-btn">
                    <el-dropdown trigger="click">
                        <span class="el-dropdown-link userinfo-inner">
                            <i class="el-icon-user" style="margin-right: 5px;"></i>{{username}}<i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item @click.native="changePw">修改密码</el-dropdown-item>
                            <el-dropdown-item @click.native="logout">退出登录</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
            </div>
        </div>
        <!--左侧菜单-->
        <div class="container-main">
            <aside :class="{showSidebar:!collapsed}">
                <el-menu :default-active="defaultActiveIndex" router class="left-menu" background-color="#f6f7f9"
                         text-color="#5d6165">
                    <!--<el-menu-item index="/index">-->
                        <!--<i class="el-icon-monitor"></i>-->
                        <!--<span slot="title">后台管理首页</span>-->
                    <!--</el-menu-item>-->
                    <div v-for="(item, index) in menuList" :key="index">
                        <template v-if="item.menuName">
                            <el-submenu :index="item.id.toString()">
                                <!--一级菜单只展开-->
                                <template slot="title">
                                    <i :class="item.icon"></i>
                                    <span>{{item.menuName}}</span>
                                </template>
                                <div v-for="(term, index2) in item.list1" :key="index2">
                                    <!--<template v-if="term.menuShow">-->
                                    <!--二级菜单可点击-->
                                    <el-menu-item  :index="'/' + term.route" @click="handleMenu(term)">
                                        <span slot="title">{{term.menuName}}</span>
                                    </el-menu-item>
                                </div>
                            </el-submenu>
                        </template>
                    </div>
                </el-menu>
            </aside>
            <!--右侧内容区-->
            <div class="grid-content bg-purple-light content-container">
                <!-- <breadcrumb/> -->
                <!--<common-tag></common-tag>-->
                <tags-view></tags-view>
                <div class="content-page">
                    <!--<div class="content-tab">-->
                        <!--<el-tag :class="tagsIndex == 0 ? 'active' : ''">首页</el-tag>-->
                        <!--<el-tag-->
                                <!--v-for="(tag, index) in tags"-->
                                <!--:key="tag.name"-->
                                <!--closable-->
                                <!--@close="handleClose(tag)"-->
                                <!--:class="tagsIndex == index"-->
                        <!--&gt;-->
                            <!--{{tag.name}}-->
                        <!--</el-tag>-->
                    <!--</div>-->
                    <transition name="fade-transform" mode="out-in">
                        <router-view></router-view>
                    </transition>
                </div>
                <!--<div class="footer center">-->
                    <!--<p>中宣部信息中心监测处监制｜开发者：杭州作客文化传媒有限公司</p>-->
                <!--</div>-->
            </div>
        </div>
        <el-dialog title="修改密码" :visible.sync="pwDialogVisible" width="600px" center>
            <el-form :rules="rules" ref="ruleForm" :model="ruleForm" label-width="100px"
                     class="el-form--label-left"
                     style="max-height: 450px;padding: 0 30px;overflow: auto;line-height: 30px;">
                <el-form-item label="原密码：" clearable prop="oldPassword">
                    <el-input type="password" v-model="ruleForm.oldPassword" clearable="" style="width: 300px;"></el-input>
                </el-form-item>
                <el-form-item label="新密码：" clearable prop="newPassword">
                    <el-input type="password" v-model="ruleForm.newPassword" clearable="" style="width: 300px;"></el-input>
                </el-form-item>
                <el-form-item label="确认密码：" clearable prop="newPassword2">
                    <el-input type="password" v-model="ruleForm.newPassword2" clearable="" style="width: 300px;"></el-input>
                </el-form-item>
                <el-form-item size="large">
                    <el-button type="primary" style="width: 300px;" @click="editDialogSureBtn('ruleForm')">修改密码</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
        <agent-pop :visible.sync="isShowDialogAgent"></agent-pop>
    </div>
</template>
<script>
// import Breadcrumb from '@/layout/components/Breadcrumb'
import AgentPop from '@/components/AgentPop'
import AppList from '@/layout/components/AppList'
import TagsView from '@/layout/components/TagsView'
// import CommonTag from '@/layout/components/CommonTag'
// import CommonTag from '@/layout/components/CommonTag'
// import TagsMenu from '@/layout/components/TagsMenu'
// import { Breadcrumb, TagsView } from './components'
// import { mapState } from 'vuex'
// import { mapMutations, mapState } from 'vuex';
export default {
    name: 'layout',
    components: {
        // Breadcrumb,
        AgentPop,
        AppList,
        TagsView
    },
    data () {
        return {
            appObj: {},
            hostname: '',
            menuList: [],
            pwDialogVisible: false,
            username: '',
            // defaultActiveIndex: this.$router.options.routes[3].children[0].path,
            defaultActiveIndex: '/ys-banner-list',
            collapsed: false,
            breadcrumbList: [],
            tagsIndex: 0,
            tags: [
            ],
            ruleForm: {
                oldPassword: '',
                newPassword: '',
                newPassword2: ''
            },
            rules: {
                oldPassword: [
                    {required: true, message: '请输入原密码', trigger: 'blur'}
                ],
                newPassword: [
                    {required: true, message: '请输入新密码', trigger: 'blur'}
                ],
                newPassword2: [
                    {required: true, message: '请输入确认密码', trigger: 'blur'}
                ]
            },
            isShowDialogAgent: false,
            // status: 0,
            // openId: ['/base-data']
        }
    },
    computed: { 
        //有子菜单
        // menuList() {
        //     return this.menuData.filter(item => item.children)
        // }
    },
    watch: {
        $route() {
            console.log(this.$route.path)
            this.defaultActiveIndex = this.$route.path
            // if (!JSON.parse(localStorage.getItem('accountInfo')).bangdingAppId) {
            //     if (this.$route.path == '/agent-ad-unlock-config' || this.$route.path == '/return-config' || this.$route.path == '/pro-link-list') {
            //         this.isShowDialogAgent = true
            //     } else {
            //         this.isShowDialogAgent = false
            //     } 
            // }
        }
    },
    created () {
        this.appObj = JSON.parse(localStorage.getItem('appObj'))
        this.defaultActiveIndex = this.$route.path
        this.username = localStorage.getItem('currentUser_name')
        this.menuList = JSON.parse(localStorage.getItem('menuList'))
        console.log(this.menuList)
        this.hostname = window.location.hostname
    },
    mounted () {
        console.log(this.defaultActiveIndex)
        // this.getAppList()
        console.log(window.location.hostname)
    },
    methods: {
        // 从组件获取appid
        getAppObj(data) {
            this.appObj = data
            console.log(data)
            // this.getTableData()
        },
        handleClose(tag) {
            this.tags.splice(this.tags.indexOf(tag), 1);
        },
        handleMenu(item) {
            if(this.$route.path !== item.path && !(this.$route.path === JSON.parse(localStorage.getItem('defultTag')).route.route && (item.path ==='/'))) {
                console.log("item.route",item.route)
                this.$router.push(item.route);
                // const fullPath = this.$router.resolve({path:'/'+item.route}).href;
                // window.open(fullPath, '_blank');
            }
            this.$store.commit('selectMenu', item);
        },
        logout () {
            this.$confirm('确认退出吗?', '提示', {
                confirmButtonClass: 'el-button--warning'
            }).then(() => {
                this.$store.dispatch('home/loginOut', {'router': this.$router})
            }).catch(() => {})
        },
        changePw () {
            this.ruleForm = {
                oldPassword: '',
                newPassword: '',
                newPassword2: ''
            }
            if (this.$refs['ruleForm'] !== undefined) {
                this.$refs['ruleForm'].resetFields()
            }
            this.pwDialogVisible = true
        },
        // 弹框确定
        editDialogSureBtn(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.axios({
                        method: 'get',
                        url: '/v1/account/updPassWord',
                        params: {
                            oldPassword: this.ruleForm.oldPassword,
                            newPassword: this.ruleForm.newPassword,
                            newPassword2: this.ruleForm.newPassword2
                        }
                    }).then((response) => {
                        if (response.data.content === 1) {
                            this.$message({
                                message: '修改成功',
                                type: 'success'
                            });
                            this.pwDialogVisible = false
                        } else {
                            this.$message.error(response.data.head.desc);
                        }
                    })
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        // // 菜单接口
        // getMenuList () {
        //     this.axios({
        //         method: 'get',
        //         url: '/v1/sys/permission/tree',
        //         params: {
        //         }
        //     }).then((response) => {
        //        console.log(response)
        //     })
        // }
        // 小程序列表接口
        // getAppList () {
        //     this.axios({
        //         method: 'get',
        //         url: '/video/info/getAppList',
        //         params: {
        //             pageNo: 1,
        //             pageSize: 100
        //         }
        //     }).then((response) => {
        //        console.log(response)
        //         localStorage.setItem('appList', JSON.stringify(response.data.content))
        //         // localStorage.setItem('AppId', response.data.content[0].appId)
        //     })
        // }
    }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
